import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-video-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './video-modal.html',
  styleUrl: './video-modal.scss'
})
export class VideoModal {
  @Input() isOpen = false;
  @Output() closeModal = new EventEmitter<void>();
  
  s3BaseUrl = environment.s3BaseUrl;

  onCloseModal() {
    this.closeModal.emit();
  }

  onBackdropClick(event: MouseEvent) {
    // Cerrar modal si se hace clic en el backdrop (no en el contenido)
    if (event.target === event.currentTarget) {
      this.onCloseModal();
    }
  }

  getVideoUrl(path: string): string {
    return `${this.s3BaseUrl}/${path}`;
  }
}
